import { render, staticRenderFns } from "./article_liste.vue?vue&type=template&id=56a45de4&"
import script from "./article_liste.vue?vue&type=script&lang=js&"
export * from "./article_liste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports